/*******************************************************************************
 * CheckPayment */
/**
 * @ngdoc   run
 * @module  csm.books.nsf
 * @name    csm.books.nsf.run:CheckPayment
 * @description
 * Creates a data object constructor by setting default values and functions on
 * the prototype. The data will be initialized from the `check`.
 *******************************************************************************/
/* @ngInject */ export function runCheckPaymentData(Data) {
  /*****************************************************************************
   * Constructor
   *****************************************************************************/
  Data.CheckPayment = function (check) {
    var checkPayment = Object.assign(
      Object.create(Data.CheckPayment.prototype),
      check || {}
    );

    /*-------------------------------------*/
    /* Map and rename the itemsList array. */
    /*-------------------------------------*/
    if (check && check.itemsList) {
      checkPayment.reversals = check.itemsList.map(function (item) {
        return new Data.ItemReversal(item);
      });

      delete checkPayment.itemsList;
    }

    /*--------------------------------------------*/
    /* Preset the receiptFrom object from the id. */
    /*--------------------------------------------*/
    if (check && check.receiptFromID)
      checkPayment.receiptFrom = {
        entity: { id: check.receiptFromID, name: '' }
      };

    return checkPayment;
  };

  /*****************************************************************************
   * Prototype
   *****************************************************************************/
  Data.CheckPayment.prototype = {
    id: NaN,
    bankAcctID: NaN,
    checkAmount: 0,
    checkName: null,
    checkNumber: null,
    receiptFromID: NaN,
    receiptID: NaN,
    reversals: [],
    mReceiptFrom: null,

    get funds() {
      return this.hasEntity ? this.mReceiptFrom.entity.funds : 0;
    },
    get receiptFrom() {
      return this.mReceiptFrom;
    },
    get totalReversed() {
      return this.reversals.reduce(function (total, reversal) {
        return total - reversal.reversal;
      }, 0);
    },
    get entityID() {
      return this.hasEntity ? this.mReceiptFrom.entity.id || 0 : 0;
    },
    get hasEntity() {
      if (!this.mReceiptFrom);
      else if (!this.mReceiptFrom.entity);
      else return true;
    },

    set receiptFrom(value) {
      this.mReceiptFrom = value;
    }
  };
};
